module.exports = __webpack_public_path__ + "static/media/uk_flag.c4cd6642.svg";